// views/seat-labels.js: #11b: map a game snapshot to per-seat display labels.
//
// Pure (no DOM/preact) so it's unit-testable and reusable by the table
// renderer, the canvas aria-label, and the TrumpSplash "Maker" line.
//
// Prefers the snapshot's seat_occupants display_name (real human + bot names,
// now populated by the server), shows "You" for the local player's seat, and
// falls back to "Bot N" only when seat_occupants is absent (an older server,
// or a snapshot that predates the wiring). Before this, the canvas used
// hardcoded "Player 1"/"Bot Atom" labels, so a real human teammate read as a
// bot, the visible half of bug #11 ("humans replaced by AI").

/**
 * @param {any} snap                            server game snapshot
 * @param {number|null|undefined} mySeatIndex   0..3 (zero-based) or null
 * @returns {Record<number, string>}            lua-seat (1..4) → label
 */
export function seatLabelsFromSnapshot(snap, mySeatIndex) {
  /** @type {Record<number, string>} */
  const out = {};
  const occs = snap?.seat_occupants || {};
  const plain = plainSeatLabelsFromSnapshot(snap, mySeatIndex);
  for (const lua of [1, 2, 3, 4]) {
    const occ = occs[lua] || occs[String(lua)];
    // A seat a bot holds for its human, or the seat of a human who left,
    // gets the mark on its name plate.
    out[lua] = occ?.bot_held || occ?.departed ? `${plain[lua]} · bot` : plain[lua];
  }
  return out;
}

/**
 * Seat names for running text (the log, the trump splash, the dealer
 * line, the recap): the same names without the plate's "· bot" mark.
 *
 * @param {any} snap
 * @param {number|null|undefined} mySeatIndex
 * @returns {Record<number, string>}
 */
export function plainSeatLabelsFromSnapshot(snap, mySeatIndex) {
  /** @type {Record<number, string>} */
  const out = {};
  const occs = snap?.seat_occupants || {};
  const myLuaSeat = mySeatIndex != null ? mySeatIndex + 1 : null;
  for (const lua of [1, 2, 3, 4]) {
    const occ = occs[lua] || occs[String(lua)];
    out[lua] = lua === myLuaSeat ? 'You' : (occ?.display_name || `Bot ${lua}`);
  }
  return out;
}
